const monthYear = (locale) =>
  new Intl.DateTimeFormat(locale, {
    month: "long",
    year: "numeric",
  }).format(new Date());

const currentYear = new Date().getFullYear();

const translations = {
  nl: {
    home_meta_title: `Actuele kortingscodes en aanbiedingen - tipdeal.nl ${monthYear("nl-NL")}`,
    home_meta_description: `Vind actuele kortingscodes, aanbiedingen en deals van online winkels. Nieuwe kortingen en promoties verzameld op tipdeal.nl.`,
    home_h1: `Actuele kortingscodes en aanbiedingen`,
    meta_h1a: `Bij Tipdeal.nl vindt u actuele kortingscodes, aanbiedingen en deals voor online winkels.`,
    home_h2: `Uitgelichte kortingen van populaire winkels`,
    home_h2a: `Kortingscodes en deals van populaire winkels`,
    search: `Zoeken`,
    couponpage_meta_title: `[discount] korting ⇒ [storename] kortingscode ➤ ${monthYear("nl-NL")} - tipdeal.nl`,
    // couponpage_meta_title: `[storename] Kortingscode & Actiecode √ [discount] korting ➤ ${monthYear("nl-NL")}`,
    couponpage_meta_description: `Actuele [storename] kortingscodes en aanbiedingen van ${monthYear("nl-NL")} met beschikbare deals en promoties.`,
    couponpage_h1: `[storename] kortingscodes - ${monthYear("nl-NL")}`,
    couponpage_h3: `Actuele [storename] kortingscodes`,
    offersavailable: `Beschikbare aanbiedingen`,
    offerverified: `[offers with codes] geverifieerde kortingscodes`,
    filter_all: `Alles`,
    filter_title: `Kortingstype`,
    filter_codes: `Codes ([nrofcodes])`,
    filter_offers: `Aanbiedingen ([nrofoffers])`,
    filter_percent: `% korting ([nrofferswithpercent])`,
    filter_discount: `€ korting ([nrofferswithamount])`,
    popularstores: `Populaire winkels`,
    verified: `Geverifieerd`,
    discount: `Korting`,
    offerusedtoday: `[hits] keer bekeken vandaag`,
    usedtoday: `[totalhits] keer bekeken vandaag`,
    expires: `Verloopt: [expiry_date]`,
    code_button: `Code bekijken`,
    offer_button: `Aanbieding bekijken`,
    copycode_button: `Code kopiëren`,
    copycode_button_go: `Code inwisselen`,
    previous: `Vorige`,
    next: `Meer`,
    code: `Code`,
    offer: `Aanbieding`,
    details: `Details`,
    expiresin: `Verloopt om`,
    email: ``,
    copyright: `<a href="https://www.tipdeal.nl/privacy-and-cookies">Privacy</a> &middot; <a href="https://www.tipdeal.nl/imprint">Impressum</a> &middot; <a href="https://www.tipdeal.nl/terms-and-conditions">Voorwaarden</a> © ${currentYear} <a href="https://www.tipdeal.nl/imprint">IMP Multimedia</a>`,
    popularsites: `Populaire websites: <a target='_blank' href='https://www.nos.nl/' rel='noopener noreferrer'>nos.nl</a>, <a target='_blank' href='https://www.bol.com/' rel='noopener noreferrer'>bol.com</a>, <a target='_blank' href='https://www.marktplaats.nl/' rel='noopener noreferrer'>marktplaats.nl</a>`,
    locale: `nl-NL`,
    countrycode: `nl`,
    disclaimer: `Deze website bevat affiliate links.`,
    abc_h1_title: `Alle winkels met kortingen`,
    abc_link: `[storenr] andere winkels met de [letter]`,
    abc_h1_title_all: `Alle winkels met [letter]`,
    abc_link_all: `Winkels A-Z`,
    officialdata_title: `Goed om te weten`,
    max_discount_label: `Hoogste korting momenteel beschikbaar`,
    avg_discount_label: `Gemiddelde korting deze maand`,
    savings_types: `Bespaarmogelijkheden`,
    savings_sale: `Sale`,
    savings_bogo: `Buy X Get Y`,
    savings_bundle: `Bundels`,
    savings_welcome: `Welkomstbonus`,
    savings_newsletter: `Nieuwsbrief`,
    savings_freeshipping: `Gratis verzending`,
    savings_loyalty: `Loyaliteit`,
    savings_student: `Student`,
    savings_military: `Militair`,
    savings_firstorder: `Eerste bestelling`,
    savings_clearance: `Uitverkoop`,
    savings_flash: `Flash sale`,
    savings_app: `App-korting`,
    savings_payment: `Betalingskorting`,
    savings_cashback: `Cashback`,
    savings_seasonal: `Seizoensdeal`,
    savings_freetrial: `Gratis proef`,
    savings_deals: `Deals`,
    savings_giftcard: `Cadeaubon`,
    savings_freespins: `Gratis spins`,
    savings_subscription: `Abonnement`,
    savings_tradein: `Inruil`,
    savings_wholesale: `Groothandel`,
    savings_pricematch: `Prijs garantie`,
    savings_senior: `Senioren`,
    savings_teacher: `Leraren`,
    savings_healthcare: `Gezondheidszorg`,
    savings_employee: `Personeelskorting`,
    bottom_anchor: `Wat je moet weten`,
    ai_button: `Zoek extra kortingscodes`,
    ai_searching: `We zoeken naar extra kortingen...`,
    ai_found: `Mogelijke extra kortingen gevonden`,
    ai_text: `Ons systeem kan soms extra kortingscodes vinden`,
    ai_none_found: `Op dit moment geen extra kortingen gevonden.`,
    events_title: `Shopping Events en Seizoensaanbiedingen`,
    events_description: `Ontdek shopping events, seizoensacties en speciale aanbiedingen. Vind de beste momenten om te besparen.`,
    events_h1: `Shopping Events`,
    stores_az_title: `Winkels A-Z – Kortingscodes en Aanbiedingen`,
    stores_az_description: `Bekijk alle winkels op alfabetische volgorde en ontdek actuele kortingscodes, coupons en aanbiedingen.`,
    stores_az_h1: `Winkels A-Z`,
    offers_updated_on: `Aanbiedingen bijgewerkt op`,
    showmore: `Meer informatie »`,
    showdescr: false,
  },

  be: {
    home_meta_title: `Actuele kortingscodes en promoties in België - tipdeal.be ${monthYear("nl-BE")}`,
    home_meta_description: `Vind actuele promotiecodes, kortingscodes en deals voor Belgische webshops. Nieuwe kortingen en aanbiedingen verzameld op tipdeal.be.`,
    home_h1: `Actuele kortingscodes en promoties in België`,
    meta_h1a: `Tipdeal.be verzamelt actuele promotiecodes, kortingscodes en deals voor Belgische webshops.`,
    home_h2: `Uitgelichte deals van populaire winkels`,
    home_h2a: `Kortingscodes, promoties en deals voor België`,
    search: `Zoeken`,
    couponpage_meta_title: `[discount] besparing ⇒ [storename] promotiecode ➤ ${monthYear("nl-BE")} - tipdeal.be`,
    couponpage_meta_description: `Bekijk actuele [storename] deals en promotiecodes van ${monthYear("nl-BE")} op tipdeal.be.`,
    couponpage_h1: `[storename] kortingscodes en promoties voor België - ${monthYear("nl-BE")}`,
    couponpage_h3: `Actuele kortingscodes van [storename] in België`,
    offersavailable: `Huidige deals`,
    offerverified: `[offers with codes] Beschikbare acties`,
    filter_all: `Alles`,
    filter_title: `Type korting`,
    filter_codes: `Codes ([nrofcodes])`,
    filter_offers: `Deals ([nrofoffers])`,
    filter_percent: `% korting ([nrofferswithpercent])`,
    filter_discount: `€ korting ([nrofferswithamount])`,
    popularstores: `Populaire winkels in België`,
    verified: `Geverifieerd`,
    discount: `Korting`,
    offerusedtoday: `[hits] keer bekeken vandaag`,
    usedtoday: `[totalhits] keer bekeken vandaag`,
    expires: `Geldig tot: [expiry_date]`,
    code_button: `Bekijk code`,
    offer_button: `Bekijk aanbieding`,
    copycode_button: `Kopieer code`,
    copycode_button_go: `Code toepassen`,
    previous: `Vorige`,
    next: `Volgende`,
    code: `Code`,
    offer: `Aanbieding`,
    details: `Details`,
    expiresin: `Verloopt om`,
    email: ``,
    copyright: `<a href="https://www.tipdeal.be/privacy-and-cookies">Privacy</a> &middot; <a href="https://www.tipdeal.be/imprint">Impressum</a> &middot; <a href="https://www.tipdeal.be/terms-and-conditions">Voorwaarden</a> © ${currentYear} <a href="https://www.tipdeal.be/imprint">IMP Multimedia</a>`,
    popularsites: `Populaire websites: <a target='_blank' href='https://www.hln.be/' rel='noopener noreferrer'>hln.be</a>, <a target='_blank' href='https://www.bol.com/be/' rel='noopener noreferrer'>bol.com/be</a>, <a target='_blank' href='https://www.2dehands.be/' rel='noopener noreferrer'>2dehands.be</a>`,
    locale: `nl-BE`,
    countrycode: `be`,
    disclaimer: `Deze website bevat affiliate links.`,
    abc_h1_title: `Winkels met promotiecodes`,
    abc_link: `[storenr] webshops met de letter [letter]`,
    abc_h1_title_all: `Alle webshops beginnend met [letter]`,
    abc_link_all: `Winkels A-Z`,
    officialdata_title: `Goed om te weten`,
    max_discount_label: `Hoogste korting momenteel beschikbaar`,
    avg_discount_label: `Gemiddelde korting deze maand`,
    savings_types: `Bespaarmogelijkheden`,
    savings_sale: `Sale`,
    savings_bogo: `Buy X Get Y`,
    savings_bundle: `Bundels`,
    savings_welcome: `Welkomstbonus`,
    savings_newsletter: `Nieuwsbrief`,
    savings_freeshipping: `Gratis verzending`,
    savings_loyalty: `Loyaliteit`,
    savings_student: `Student`,
    savings_military: `Militair`,
    savings_firstorder: `Eerste bestelling`,
    savings_clearance: `Uitverkoop`,
    savings_flash: `Flash sale`,
    savings_app: `App-korting`,
    savings_payment: `Betalingskorting`,
    savings_cashback: `Cashback`,
    savings_seasonal: `Seizoensdeal`,
    savings_freetrial: `Gratis proef`,
    savings_deals: `Deals`,
    savings_giftcard: `Cadeaubon`,
    savings_freespins: `Gratis spins`,
    savings_subscription: `Abonnement`,
    savings_tradein: `Inruil`,
    savings_wholesale: `Groothandel`,
    savings_pricematch: `Prijs garantie`,
    savings_senior: `Senioren`,
    savings_teacher: `Leraren`,
    savings_healthcare: `Gezondheidszorg`,
    savings_employee: `Personeelskorting`,
    bottom_anchor: `Wat je moet weten`,
    ai_button: `Zoek extra kortingscodes`,
    ai_searching: `We zoeken naar extra kortingen...`,
    ai_found: `Mogelijke extra kortingen gevonden`,
    ai_text: `Ons systeem kan soms extra kortingscodes vinden`,
    ai_none_found: `Op dit moment geen extra kortingen gevonden.`,
    events_title: `Shopping Events en Seizoensaanbiedingen`,
    events_description: `Ontdek shopping events, seizoensacties en speciale aanbiedingen. Vind de beste momenten om te besparen.`,
    events_h1: `Shopping Events`,
    stores_az_title: `Winkels A-Z – Kortingscodes en Aanbiedingen`,
    stores_az_description: `Bekijk alle winkels op alfabetische volgorde en ontdek actuele kortingscodes, coupons en aanbiedingen.`,
    stores_az_h1: `Winkels A-Z`,
    offers_updated_on: `Aanbiedingen bijgewerkt op`,
    showmore: `Meer informatie »`,
    showdescr: true,
  },

  br: {
    home_meta_title: `Cupons de desconto e ofertas atuais - 1001 Cupons ${monthYear("pt-BR")}`,
    home_meta_description: `Encontre cupons de desconto, ofertas e promoções atuais para lojas online no Brasil. Novos descontos reunidos na 1001 Cupons.`,
    home_h1: `Cupons de desconto e ofertas atuais`,
    meta_h1a: `No 1001cupomdedescontos.com.br você encontra cupons de desconto, ofertas e promoções para lojas online.`,
    home_h2: `Cupons e ofertas em destaque de lojas populares`,
    home_h2a: `Cupons de desconto e ofertas de lojas populares`,
    search: `Pesquisar`,
    couponpage_meta_title: `Cupom de desconto [storename] [discount] OFF ⇒ Cupom [storename] - ${monthYear("pt-BR")}`,
    // couponpage_meta_title: `Cupom de desconto [storename] & Código promocional √ [discount] desconto ➤ ${monthYear("pt-BR")}`,
    couponpage_meta_description: `Cupom [storename] e ofertas atuais de ${monthYear("pt-BR")}." para compras online no Brasil.`,
    couponpage_h1: `Cupom de desconto [storename] - ${monthYear("pt-BR")}`,
    couponpage_h3: `Cupons de desconto atuais [storename]`,
    offersavailable: `Cupons de desconto disponíveis`,
    offerverified: `[offers with codes] cupons de desconto atuais`,
    filter_all: `Todos`,
    filter_title: `Tipo de desconto`,
    filter_codes: `Códigos ([nrofcodes])`,
    filter_offers: `Ofertas ([nrofoffers])`,
    filter_percent: `% desconto ([nrofferswithpercent])`,
    filter_discount: `Desconto de R$ ([nrofferswithamount])`,
    popularstores: `Lojas populares`,
    verified: `Verificado`,
    discount: `Desconto`,
    offerusedtoday: `[hits] vezes usado hoje`,
    usedtoday: `[totalhits] vezes usado hoje`,
    expires: `Expira em: [expiry_date]`,
    code_button: `Ver código`,
    offer_button: `Ver oferta`,
    copycode_button: `Copiar código`,
    copycode_button_go: `Ir para Loja`,
    previous: `Anterior`,
    next: `Mais`,
    code: `Código`,
    offer: `Oferta`,
    details: `Detalhes`,
    expiresin: `Expira em`,
    email: ``,
    copyright: `<a href="https://www.1001cupomdedescontos.com.br/privacy-and-cookies">Política</a> &middot; <a href="https://www.1001cupomdedescontos.com.br/imprint">Empresa</a> &middot; <a href="https://www.1001cupomdedescontos.com.br/terms-and-conditions">Termos</a> © ${currentYear} <a href="https://www.1001cupomdedescontos.com.br/imprint">IMP Multimedia</a>`,
    popularsites: `Sites populares: <a target='_blank' href='https://www.globo.com/' rel='noopener noreferrer'>globo.com</a>, <a target='_blank' href='https://www.terra.com.br/' rel='noopener noreferrer'>terra.com.br</a>, <a target='_blank' href='https://www.caixa.gov.br/' rel='noopener noreferrer'>caixa.gov.br</a>`,
    locale: `pt-BR`,
    countrycode: `br`,
    disclaimer: `Este site contém links de afiliados.`,
    abc_h1_title: `Todas as lojas com descontos`,
    abc_link: `[storenr] outras lojas com [letter]`,
    abc_h1_title_all: `Todas as lojas com [letter]`,
    abc_link_all: `Lojas A-Z`,
    officialdata_title: `Dicas úteis`,
    max_discount_label: `Maior desconto disponível agora`,
    avg_discount_label: `Desconto médio este mês`,
    savings_types: `Formas de economizar`,
    savings_sale: `Promoção`,
    savings_bogo: `Leve X Pague Y`,
    savings_bundle: `Pacotes`,
    savings_welcome: `Boas-vindas`,
    savings_newsletter: `Newsletter`,
    savings_freeshipping: `Envio grátis`,
    savings_loyalty: `Fidelidade`,
    savings_student: `Estudante`,
    savings_military: `Militar`,
    savings_firstorder: `1ª compra`,
    savings_clearance: `Liquidação`,
    savings_flash: `Oferta relâmpago`,
    savings_app: `App`,
    savings_payment: `Pagamento`,
    savings_cashback: `Cashback`,
    savings_seasonal: `Sazonal`,
    savings_freetrial: `Teste grátis`,
    savings_deals: `Ofertas`,
    savings_giftcard: `Cartão presente`,
    savings_freespins: `Giros grátis`,
    savings_subscription: `Assinatura`,
    savings_tradein: `Troca`,
    savings_wholesale: `Atacado`,
    savings_pricematch: `Menor preço`,
    savings_senior: `Sénior`,
    savings_teacher: `Professores`,
    savings_healthcare: `Saúde`,
    savings_employee: `Funcionários`,
    ai_searching: `Buscando...`,
    ai_found: `Possíveis descontos adicionais`,
    ai_text: `Nosso sistema pode às vezes encontrar cupons de desconto extras`,
    ai_none_found: `No momento, não encontramos outros cupons.`,
    events_title: `Eventos de Compras e Promoções Sazonais`,
    events_description: `Descubra eventos de compras, promoções sazonais e ofertas especiais para economizar durante todo o ano.`,
    events_h1: `Eventos de Compras`,
    stores_az_title: `Lojas A-Z – Cupons e Descontos`,
    stores_az_description: `Navegue por todas as lojas em ordem alfabética e encontre cupons, códigos promocionais e ofertas.`,
    stores_az_h1: `Lojas A-Z`,
    offers_updated_on: `Ofertas atualizadas em`,
    showmore: `Ver detalhes »`,
    showdescr: true,
  },

  es: {
    home_meta_title: `Cupones de descuento y ofertas actuales en España ${monthYear("es-ES")}`,
    home_meta_description: `Encuentra cupones de descuento, ofertas y promociones actuales para tiendas online en España. Nuevos descuentos reunidos en codigosdescuentospromocionales.es.`,
    home_h1: `Cupones de descuento y ofertas actuales en España`,
    meta_h1a: `En codigosdescuentospromocionales.es encuentras cupones, ofertas y promociones para tiendas online en España.`,
    home_h2: `Cupones y ofertas destacadas de tiendas populares`,
    home_h2a: `Cupones de descuento y ofertas de tiendas populares`,
    search: `Buscar`,
    couponpage_meta_title: `Código descuento [storename] [discount] OFF - ${monthYear("es-ES")}`,
    couponpage_meta_description: `Códigos de descuento y ofertas actuales de [storename] en España, con promociones disponibles y ahorro actualizado.`,
    couponpage_h1: `Código descuento [storename] - ${monthYear("es-ES")}`,
    couponpage_h3: `Códigos de descuento actuales de [storename] en España`,
    offersavailable: `Códigos y ofertas disponibles`,
    offerverified: `[offers with codes] códigos de descuento actuales`,
    filter_all: `Todos`,
    filter_title: `Tipo de descuento`,
    filter_codes: `Códigos ([nrofcodes])`,
    filter_offers: `Ofertas ([nrofoffers])`,
    filter_percent: `% descuento ([nrofferswithpercent])`,
    filter_discount: `€ Descuento ([nrofferswithamount])`,
    popularstores: `Tiendas populares en España`,
    verified: `Verificado`,
    discount: `Descuento`,
    offerusedtoday: `[hits] veces visto hoy`,
    usedtoday: `[totalhits] veces visto hoy`,
    expires: `Expira en: [expiry_date]`,
    code_button: `Ver código`,
    offer_button: `Ver oferta`,
    copycode_button: `Copiar código`,
    copycode_button_go: `Canjear código`,
    previous: `Anterior`,
    next: `Más`,
    code: `Código`,
    offer: `Oferta`,
    details: `Detalles`,
    expiresin: `Expira en`,
    email: ``,
    copyright: `<a href="https://www.codigosdescuentospromocionales.es/privacy-and-cookies">Privacidad</a> &middot; <a href="https://www.codigosdescuentospromocionales.es/imprint">Empresa</a> &middot; <a href="https://www.codigosdescuentospromocionales.es/terms-and-conditions">Términos</a> © ${currentYear} <a href="https://www.codigosdescuentospromocionales.es/imprint">IMP Multimedia</a>`,
    popularsites: `Sitios populares en España: <a target='_blank' href='https://www.elmundo.es/' rel='noopener noreferrer'>elmundo.es</a>, <a target='_blank' href='https://www.sport.es/' rel='noopener noreferrer'>sport.es</a>, <a target='_blank' href='https://www.aliexpress.com/' rel='noopener noreferrer'>aliexpress.com</a>`,
    locale: `es-ES`,
    countrycode: `es`,
    disclaimer: `Este sitio web contiene enlaces de afiliación.`,
    abc_h1_title: `Todas las tiendas con descuentos en España`,
    abc_link: `[storenr] otras tiendas con [letter]`,
    abc_h1_title_all: `Todas las tiendas que comienzan con [letter]`,
    abc_link_all: `Tiendas de la A a la Z`,
    officialdata_title: `Consejos útiles`,
    max_discount_label: `Mayor descuento disponible ahora`,
    avg_discount_label: `Descuento medio este mes`,
    savings_types: `Formas de ahorrar`,
    savings_sale: `Rebajas`,
    savings_bogo: `Lleva X Y gratis`,
    savings_bundle: `Paquetes`,
    savings_welcome: `Bienvenida`,
    savings_newsletter: `Newsletter`,
    savings_freeshipping: `Envío gratis`,
    savings_loyalty: `Fidelidad`,
    savings_student: `Estudiante`,
    savings_military: `Militar`,
    savings_firstorder: `Primer pedido`,
    savings_clearance: `Liquidación`,
    savings_flash: `Ofertas flash`,
    savings_app: `App`,
    savings_payment: `Pago`,
    savings_cashback: `Cashback`,
    savings_seasonal: `Temporada`,
    savings_freetrial: `Prueba gratis`,
    savings_deals: `Ofertas`,
    savings_giftcard: `Tarjeta regalo`,
    savings_freespins: `Giros gratis`,
    savings_subscription: `Suscripción`,
    savings_tradein: `Intercambio`,
    savings_wholesale: `Mayorista`,
    savings_pricematch: `Mejor precio`,
    savings_senior: `Senior`,
    savings_teacher: `Profesores`,
    savings_healthcare: `Salud`,
    savings_employee: `Empleados`,
    ai_searching: `Estamos buscando...`,
    ai_found: `Posibles descuentos adicionales`,
    ai_text: `Nuestro sistema puede encontrar a veces códigos de descuento adicionales`,
    ai_none_found: `No hemos encontrado más códigos en este momento.`,
    events_title: `Eventos de Compras y Promociones Estacionales`,
    events_description: `Descubre eventos de compras, promociones de temporada y ofertas especiales para ahorrar durante todo el año.`,
    events_h1: `Eventos de Compras`,
    stores_az_title: `Tiendas A-Z – Cupones y Descuentos`,
    stores_az_description: `Explora todas las tiendas en orden alfabético y encuentra cupones, códigos promocionales y ofertas.`,
    stores_az_h1: `Tiendas A-Z`,
    offers_updated_on: `Ofertas actualizadas el`,
    showmore: `Ver detalles »`,
    showdescr: true,
  },

  us: {
    home_meta_title: `Current promo codes, coupons and deals in the USA - ${monthYear("en-US")}`,
    home_meta_description: `Find current promo codes, coupons, deals and online offers for popular stores in the USA. New discounts and promotions collected for ${monthYear("en-US")}.".`,
    home_h1: `Current promo codes and deals in the USA`,
    meta_h1a: `Find current coupons, promo codes and deals for popular online stores in the United States.`,
    home_h2: `Featured discounts from popular US stores`,
    home_h2a: `Promo codes, coupons and deals from popular stores`,
    search: `Search`,
    couponpage_meta_title: `[storename] Promo Code [discount] – Current Coupon ${monthYear("en-US")}`,
    couponpage_meta_description: `View current [storename] promo codes and deals in the USA. See expiration dates, usage details, and updated savings information.`,
    couponpage_h1: `[storename] promo codes – ${monthYear("en-US")}`,
    couponpage_h3: `Available [storename] discounts in the USA`,
    offersavailable: `Available offers`,
    offerverified: `[offers with codes] current coupon codes`,
    filter_all: `All`,
    filter_title: `Discount type`,
    filter_codes: `Codes ([nrofcodes])`,
    filter_offers: `Deals ([nrofoffers])`,
    filter_percent: `% off ([nrofferswithpercent])`,
    filter_discount: `$ off ([nrofferswithamount])`,
    popularstores: `Popular stores in the USA`,
    verified: `Verified`,
    discount: `Discount`,
    offerusedtoday: `Viewed [hits] times today`,
    usedtoday: `[totalhits] viewed today`,
    expires: `Expires on: [expiry_date]`,
    expiresin: `Expires in`,
    code_button: `Show code`,
    offer_button: `View deal`,
    copycode_button: `Copy code`,
    copycode_button_go: `Go to offer`,
    previous: `Previous`,
    next: `More`,
    code: `Code`,
    offer: `Deal`,
    details: `Details`,
    email: ``,
    copyright: `<a href="https://www.1001promocodes.com/privacy-and-cookies">Privacy</a> &middot; <a href="https://www.1001promocodes.com/imprint">Imprint</a> &middot; <a href="https://www.1001promocodes.com/terms-and-conditions">Terms</a> © ${currentYear} <a href="https://www.1001promocodes.com/imprint">IMP Multimedia</a>`,
    popularsites: `Popular websites in the USA: <a target='_blank' href='https://www.nytimes.com/' rel='noopener noreferrer'>nytimes.com</a>, <a target='_blank' href='https://www.espn.com/' rel='noopener noreferrer'>espn.com</a>, <a target='_blank' href='https://www.aliexpress.com/' rel='noopener noreferrer'>aliexpress.com</a>`,
    locale: `en-US`,
    countrycode: `us`,
    disclaimer: `This website contains affiliate links.`,
    abc_h1_title: `All stores with discounts in the USA`,
    abc_link: `[storenr] more stores starting with [letter]`,
    abc_h1_title_all: `All stores that start with [letter]`,
    abc_link_all: `Browse all stores`,
    officialdata_title: `Helpful information`,
    max_discount_label: `Best discount available`,
    avg_discount_label: `Average discount this month`,
    savings_types: `Ways to save`,
    savings_sale: `Sale`,
    savings_bogo: `Buy X Get Y`,
    savings_bundle: `Bundles`,
    savings_welcome: `Welcome`,
    savings_newsletter: `Newsletter`,
    savings_freeshipping: `Free shipping`,
    savings_loyalty: `Loyalty`,
    savings_student: `Student`,
    savings_military: `Military`,
    savings_firstorder: `First order`,
    savings_clearance: `Clearance`,
    savings_flash: `Flash sale`,
    savings_app: `App`,
    savings_payment: `Payment`,
    savings_cashback: `Cashback`,
    savings_seasonal: `Seasonal`,
    savings_freetrial: `Free trial`,
    savings_deals: `Deals`,
    savings_giftcard: `Gift card`,
    savings_freespins: `Free spins`,
    savings_subscription: `Subscription`,
    savings_tradein: `Trade-in`,
    savings_wholesale: `Wholesale`,
    savings_pricematch: `Price match`,
    savings_senior: `Senior`,
    savings_teacher: `Teacher`,
    savings_healthcare: `Healthcare`,
    savings_employee: `Employee`,
    bottom_anchor: `Learn more`,
    ai_button: `Find more current deals`,
    ai_searching: `Searching for additional offers…`,
    ai_found: `Additional discounts found`,
    ai_text: `Our automated system may occasionally discover new or recently updated promo codes.`,
    ai_none_found: `No additional codes are available right now.`,
    events_title: `Shopping Events & Seasonal Promotions`,
    events_description: `Browse seasonal shopping events, holiday sales and special promotions. Discover the best times of the year to save at your favorite stores.`,
    events_h1: `Shopping Events`,
    stores_az_title: `Stores A-Z – Coupons & Discounts`,
    stores_az_description: `Browse all stores alphabetically and discover the latest coupons, discount codes and special offers.`,
    stores_az_h1: `Stores A-Z`,
    offers_updated_on: `Offers updated on`,
    showmore: `View details »`,
    showdescr: true,
  },
};

export const getTranslations = (countryCode) => {
  const key = String(countryCode || "").toLowerCase();
  const data = translations[key];

  if (!data) {
    throw new Error(`Missing translations for country: ${key}`);
  }

  return data;
};